import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid, Box, Container, Paper } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { COLOR_VALUES, buttonStylesByNames, paperStyle } from '../../utils/style';
import { useAppStore } from '../../store/AppStore';
import decimalToAmerican from '../../utils/oddsConversion'

// TODO: Get rid of makeStyles()
const useStyles = makeStyles((theme) => ({
  root: {},
  paper: paperStyle(theme),
  box: {
    // display: 'inline-block',
    display: 'flex',
    alignItems: 'center'
  },
  // Add "Button" styles for Material UI names 'primary', 'secondary', 'warning', and so on
  ...buttonStylesByNames(theme),
}));

/**
 * Application styled Material UI Button with Box around to specify margins using props
 * @component AppSport
 * @param {node} [children] - content to render, overrides .label and .text
 * @param {string} [logo] - name of color from Material UI palette 'primary', 'secondary', 'warning', and so on
 * @param {string} [label] - text to render, alternate to .text
 * @param {string} [text] - text to render, alternate to .label
 */
const AppOddCell = ({
  children,
  className,
  item,
  event,
  team,
  back_lay,
  market_type,
  market_title,
  main,
  odds,
  stake,
  totalStake,
  sport,
  league,
  eventId,
  period,
  mkt,
  player,
  side,
  startDate,
  line,
  selectionName,
  displayOdds,
  ...restOfProps
}) => {
  const classes = useStyles();
  const [state, dispatch] = useAppStore();
  
  const handleOddCellClick = () => {
    dispatch({
      type: 'SELECTED_ODD',
      odd: {
        event: event,
        team: team,
        back_lay: back_lay,
        market_type: market_type,
        market_title: market_title,
        odds: odds,
        stake: stake,
        totalStake: totalStake,
        sport: sport,
        league: league,
        eventId: eventId,
        period: period,
        mkt: mkt,
        player: player,
        side: side,
        startDate: startDate,
        line: line,
        selectionName: selectionName
      }
    });
  };
  return (
    <Box component="div" sx={{
      display: 'flex', flexDirection: 'column', backgroundColor: back_lay == 'lay' ? (main ? '#B11A10' : '#AC4D47') : (main ? '#086912' : '#4B8951'),
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: back_lay == 'lay' ? (main ? '#B11A10' : '#AC4D47') : (main ? '#086912' : '#4B8951'),
      '&:hover': {
        border: '1px solid #979797',
        cursor: 'pointer'
      },
    }} onClick={handleOddCellClick}>
      <Box component="span" sx={{ textAlign: 'center', minWidth: '4rem' }}>{odds == 0 ? '-' : (state.oddsStyle ? displayOdds?displayOdds.toFixed(2):odds.toFixed(2) : displayOdds?decimalToAmerican(displayOdds):decimalToAmerican(odds))}</Box>
      <Box component="span" sx={{ textAlign: 'center', minWidth: '4rem', fontSize: '0.8rem' }}>{stake == 0 ? '-' : '$' + stake.toFixed(2)}</Box>
      <Box component="span" sx={{ textAlign: 'center', minWidth: '4rem', fontSize: '0.8rem', color: '#979797' }}>{totalStake == 0 ? '-' : '$' + totalStake.toFixed(2)}</Box>
    </Box>
  );
};

AppOddCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  logo: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  onClick: PropTypes.func,
};

export default AppOddCell;
